export const ACCEPT_PLATFORM_TERMS_KIND = {
    ONBOARDING_JWT: 'onboardingJwt',
    TERM_VERSION: 'termVersion',
};
